<template>
  <div class="invoice">
    <div class="imgShade" v-show="imgShow" @click="imgHide">
      <img src="../../static/img/invoice.png" />
    </div>
    <div class="top">
      <img class="logo" src="../../static/img/logo.png" />
      <h5 class="top_tit"><span>|</span> 会员系统</h5>
      <p class="welcom">
        欢迎您 <span class="name">{{ name }}</span
        ><span>|</span>
      </p>
      <router-link class="out" to="/login"> 退出 </router-link>
    </div>
    <div class="center">
      <p class="introducer" style="width: 960px; height: 75px; margin: 0 auto">
        预支会费票据申请 &nbsp;&nbsp;<span style="font-size: 18px; color: red"
          >新会员请确认是否通过入会审核，如未通过则无法提交“预支会费票据申请”</span
        >
      </p>
      <div class="center_con">
        <div class="con_bot">
          <div class="form_box">
            <section id="pdf" class="bot_left" ref="print">
              <h5
                class="default"
                style="text-align: center; margin-bottom: 20px"
              >
                预支会费票据申请
              </h5>
              <p style="margin-bottom: 20px">
                中国质量协会：<br />
                您好，由于 本单位财务管理规定需要先开会费票据后付款
                （或其他实际内容）
                ，我单位需贵协会提前开具全国性社会团体会费统一票据，我单位将在收到会费票据后<input
                  style="width: 30px"
                />个工作日内付款。<br />
                开票及具体联系信息如下
              </p>
              <div class="msg">
                <p>
                  <span class="w1">单位名称</span>
                  <input
                    v-model="companyname"
                    style="width: 335px"
                    placeholder="请输入单位名称"
                  />
                </p>
                <p>
                  <span class="w1">开票金额</span>
                  <input
                    style="width: 100px"
                    @blur="change_big"
                    v-model="number"
                    placeholder="开票金额"
                    type="number"
                    step="100"
                  />
                  <span style="width: 100px">元，大写人民币</span>
                  <span class="big" v-model="big_number">{{ big_number }}</span>
                </p>
                <p>
                  <span class="w1">联 系 人</span>
                  <input
                    style="width: 100px"
                    v-model="linkman"
                    placeholder="请输入联系人"
                  />
                  <span class="w1">联系电话</span>
                  <input
                    v-model="phone"
                    style="width: 115px"
                    placeholder="请输入联系电话"
                  />
                </p>
                <p style="height: 47px">
                  <span class="w1">电子邮箱</span>
                  <textarea
                    v-model="address"
                    style="width: 335px; height: 47px"
                  ></textarea>
                </p>
                <p>
                  <span class="w1" style="font-size: 12px; text-align: left"
                    >统一信用代码（税号）</span
                  >
                  <textarea
                    v-model="note"
                    style="width: 335px; height: 60px"
                  ></textarea>
                </p>
              </div>
              <!--<p style="text-align: right;margin-bottom: 20px;">单位名称（公章或财务专用章）</p>-->
              <p style="text-align: right">
                {{ time[0] }} 年 {{ time[1] }} 月 {{ time[2] }} 日
              </p>
            </section>
            <div class="btns">
              <button class="seeStyle" @click="seeStyle">查看票据样式</button>
              <button class="down_load" @click="submit">提交</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import { Message, MessageBox, Loading, alert } from 'element-ui'
import Qs from 'qs'
import bottom from './Bottom'
function filterInput (val) {
  return val.replace(/[`～*~!@#$%^&*_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*——\-+={}|《》？：“”【】、；‘'，。、]/g, '')
}
export default {
  components: {
    bottom
  },
  data () {
    return {
      imgShow: false,
      tit: '',
      name: '',
      companyname: '',
      number: '',
      big_number: '',
      linkman: '',
      phone: '',
      address: '',
      note: '',
      time: '',
      file: '',
      filename: ''
    };
  },
  watch: {
    companyname (val) {
      this.$nextTick(() => {
        this.companyname = filterInput(val)
      })
    }
  },
  created () { },
  mounted () {
    this.time = new Date().toISOString().slice(0, 10).split('-');
    if (sessionStorage.getItem('name')) {
      this.name = sessionStorage.getItem('name');
    };
    if (sessionStorage.getItem('Token')) {
      var token = sessionStorage.getItem('Token');
    };
  },
  methods: {
    seeStyle () {
      this.imgShow = true;
    },
    imgHide () {
      this.imgShow = false;
    },
    out () {
      if (sessionStorage.getItem('Token')) {
        var token = sessionStorage.getItem('Token');
      };
      var data1 = {
        'access-token': token
      };
      this.$axios({
        method: 'post',
        url: 'user/logout',
        data: Qs.stringify(data1)
      }).then(response => {
        if (response.data.state == 1) {
          //						localStorage.removeItem('sessionid');
          localStorage.clear();
          sessionStorage.clear();
          this.$router.push('/login');
        } else {
          this.$toast(response.data.msg);
        }
      })
    },
    submit () {
      var time = new Date();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      //				if(month==12 && date>=20 && date<=31){
      //					this.$alert('自12月20日起至12月31日，中国质量协会财务结算期间，借发票渠道暂时关闭，感谢您的理解与配合！', '温馨提示：', {
      //			          confirmButtonText: '确定',
      //			       });
      //					return false;
      //				}
      if (!this.companyname) {
        this.$toast('请输入单位名称');
        return false;
      };
      if (this.companyname.length > 31) {
        this.$toast('请输入正确的单位名称');
        return false;
      };
      if (!this.number) {
        this.$toast('请输入开票金额');
        return false;
      };
      if (!this.linkman) {
        this.$toast('请输入联系人');
        return false;
      };
      if (!this.phone) {
        this.$toast('请输入联系电话');
        return false;
      };
      if (!this.address) {
        this.$toast('请输入邮寄地址');
        return false;
      };
      if (!this.note) {
        this.$toast('请输入统一信用代码（税号）');
        return false;
      }
      //				if(!reg.test(this.note)){
      //					this.$toast('请输入正确的接收电子发票邮箱地址');
      //					return false;
      //				}
      if (sessionStorage.getItem('Token')) {
        var token = sessionStorage.getItem('Token');
      }

      let data = {
        'access-token': token,
        'companyName': this.companyname,
        'money_apply': this.number,
        'money_CN': this.big_number,
        'contactPerson': this.linkman,
        'tel': this.phone,
        'address': this.address,
        'taxNo': this.note,
        'date_of_sign': this.time.join('-')
      }

      this.$confirm('您所填写的信息是否已核对确认无误？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        this.$axios({
          method: 'post',
          url: 'invoiceapply/applyinvoice',
          data: Qs.stringify(data)
        }).then(response => {
          if (response.data.state == 3) {
            this.$message({
              message: '您的提前开发票申请已提交成功！',
              type: 'success'
            });
          } else {
            this.$toast(response.data.msg);
          };
        });
      }).catch(() => {

      });
    },
    change_big () {
      if (!this.number) {
        this.big_number = '';
        return false;
      }
      var value = this.number;
      var numberValue = new String(Math.round(value * 100)); // 数字金额  
      var chineseValue = ""; // 转换后的汉字金额  
      var String1 = "零壹贰叁肆伍陆柒捌玖"; // 汉字数字  
      var String2 = "万仟佰拾亿仟佰拾万仟佰拾元角分"; // 对应单位  
      var len = numberValue.length; // numberValue 的字符串长度  
      var Ch1; // 数字的汉语读法  
      var Ch2; // 数字位的汉字读法  
      var nZero = 0; // 用来计算连续的零值的个数  
      var String3; // 指定位置的数值  
      if (len > 15) {
        alert("超出计算范围");
        return "";
      }
      if (numberValue == 0) {
        chineseValue = "零元整";
        return chineseValue;
      }
      String2 = String2.substr(String2.length - len, len); // 取出对应位数的STRING2的值  
      for (var i = 0; i < len; i++) {
        String3 = parseInt(numberValue.substr(i, 1), 10); // 取出需转换的某一位的值  
        if (i != (len - 3) && i != (len - 7) && i != (len - 11) && i != (len - 15)) {
          if (String3 == 0) {
            Ch1 = "";
            Ch2 = "";
            nZero = nZero + 1;
          }
          else if (String3 != 0 && nZero != 0) {
            Ch1 = "零" + String1.substr(String3, 1);
            Ch2 = String2.substr(i, 1);
            nZero = 0;
          }
          else {
            Ch1 = String1.substr(String3, 1);
            Ch2 = String2.substr(i, 1);
            nZero = 0;
          }
        }
        else { // 该位是万亿，亿，万，元位等关键位  
          if (String3 != 0 && nZero != 0) {
            Ch1 = "零" + String1.substr(String3, 1);
            Ch2 = String2.substr(i, 1);
            nZero = 0;
          }
          else if (String3 != 0 && nZero == 0) {
            Ch1 = String1.substr(String3, 1);
            Ch2 = String2.substr(i, 1);
            nZero = 0;
          }
          else if (String3 == 0 && nZero >= 3) {
            Ch1 = "";
            Ch2 = "";
            nZero = nZero + 1;
          }
          else {
            Ch1 = "";
            Ch2 = String2.substr(i, 1);
            nZero = nZero + 1;
          }
          if (i == (len - 11) || i == (len - 3)) { // 如果该位是亿位或元位，则必须写上  
            Ch2 = String2.substr(i, 1);
          }
        }
        chineseValue = chineseValue + Ch1 + Ch2;
      }
      if (String3 == 0) { // 最后一位（分）为0时，加上“整”  
        chineseValue = chineseValue + "整";
      }
      this.big_number = chineseValue;
    },
  }
}
</script>
<style scoped>
@media print {
  @page {
    size: auto;
    /* auto is the initial value */
    margin: 0mm;
    /* this affects the margin in the printer settings */
  }
  .bot_left {
    margin: 0 auto;
    transform-origin: 50% 0;
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    -moz-transform: scale(1.2);
    -ms-transform: scale(1.2);
    -o-transform: scale(1.2);
    font-stretch: normal;
    font-family: "宋体";
  }
}

.clearfix::after {
  content: ".";
  clear: both;
  visibility: hidden;
  height: 0;
  display: block;
  line-height: 0;
}

.clearfix {
  zoom: 1;
}

.fl {
  float: left;
}

.default {
  font-size: 16px;
  font-weight: bold;
  color: #404040;
  height: 72px;
  line-height: 80px;
  letter-spacing: 1px;
  border-bottom: 1px solid #bfbfbf;
}

.invoice {
  width: 100%;
  height: auto;
  background: #fff;
  font-family: PingFangSC-Medium;
  font-size: 14px;
}

.top {
  height: 80px;
  position: relative;
}

.logo {
  width: 211px;
  height: 43px;
  position: absolute;
  top: 16px;
  left: 254px;
}

.top_tit {
  position: absolute;
  top: 26px;
  left: 480px;
  height: 28px;
  font-size: 20px;
  font-weight: bold;
  color: rgba(0, 94, 179, 1);
  line-height: 28px;
}

.top_tit span {
  height: 17px;
  color: #e8e8e8;
}

.welcom {
  position: absolute;
  top: 30px;
  right: 271px;
  width: 240px;
  color: #808080;
}

.name {
  color: #4a90e2;
  margin-right: 14px;
}

.out {
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 226px;
  font-size: 14px;
  font-weight: bold;
  color: #808080;
  line-height: 20px;
}

.imgShade {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}

.imgShade img {
  width: 760px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.center {
  border-top: 1px solid rgba(0, 0, 0, 0);
  box-sizing: border-box;
  width: 100%;
  padding-bottom: 35px;
  background: rgba(246, 248, 249, 1);
}

.introducer {
  font-size: 24px;
  color: #404040;
  text-align: left;
  line-height: 75px;
  width: 960px;
  height: 75px;
  margin: 0 auto;
}

.center_con {
  text-align: left;
  margin: 0 auto;
  width: 871px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 28px 49px 40px 40px;
}

.con_bot {
  position: relative;
  width: 100%;
}

.form_box {
  box-sizing: border-box;
  padding: 20px 10px 0;
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  border-top: 1px solid #979797;
}

.scale {
  transform-origin: 50% 0;
  transform: scale(1.8);
}

.bot_left {
  padding: 0 10px 35px;
  margin: 0 auto 20px;
  width: 486px;
  background: rgba(255, 255, 255, 1);
  /*box-shadow: 8px 8px 0px 0px rgba(0, 0, 0, 0.04);*/
  border: 1px solid rgba(220, 220, 220, 1);
}

.bot_left input {
  display: inline-block;
  height: 20px;
  text-indent: 5px;
}

.bot_left span {
  display: inline-block;
}

.msg {
  padding: 27px 19px 17px;
  background: #fffdf3;
  margin-bottom: 30px;
  box-sizing: border-box;
}

.msg p {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.w1 {
  width: 100px;
  text-align: right;
}

.big {
  width: 119px;
  height: 26px;
  border: 1px solid rgba(169, 169, 169);
  background: #fff;
  text-indent: 5px;
  box-sizing: border-box;
}

.bot_right {
  position: absolute;
  right: 10px;
  top: 20px;
  width: 292px;
  height: 411px;
  border: 1px dashed #333;
}

.btns {
  height: 40px;
  width: 506px;
  margin: 0 auto;
  text-align: center;
}

.down_load,
.seeStyle {
  cursor: pointer;
  font-size: 16px;
  width: 100px;
  height: 40px;
  border-radius: 5px;
  color: #fff;
  display: inline-block;
  border: none;
  background: #ff9600;
}
.seeStyle {
  background: #169bd5;
  width: 130px;
  margin-right: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Invoice.vue